module.exports = __webpack_public_path__ + "static/media/10x10-About-Banner.430df24a.jpg";